import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import Cookies from "@/pages/Cookies";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import LiveChat from "@/components/site/LiveChat";
import TawkChat, { TAWK_ENABLED } from "@/components/site/TawkChat";
import CookieBanner from "@/components/site/CookieBanner";
import LeadModal from "@/components/site/LeadModal";
import FloatingMascot from "@/components/site/FloatingMascot";
import SmoothScroll from "@/components/site/SmoothScroll";
import ScamAlertBar from "@/components/site/ScamAlertBar";
import { localBusinessJsonLd, organizationJsonLd } from "@/components/site/Seo";

function ScrollToTopOnNavigate() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(localBusinessJsonLd())}</script>
        <script type="application/ld+json">{JSON.stringify(organizationJsonLd())}</script>
      </Helmet>
      <div className="App font-body bg-background text-foreground">
        <BrowserRouter>
          <SmoothScroll>
            <ScamAlertBar />
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy" element={<><ScrollToTopOnNavigate /><Privacy /></>} />
            <Route path="/terms" element={<><ScrollToTopOnNavigate /><Terms /></>} />
            <Route path="/refund" element={<><ScrollToTopOnNavigate /><Refund /></>} />
            <Route path="/cookies" element={<><ScrollToTopOnNavigate /><Cookies /></>} />
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
        {TAWK_ENABLED ? <TawkChat /> : <LiveChat />}
        <CookieBanner />
        <LeadModal />
        <FloatingMascot />
        <Toaster richColors position="top-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
